import styled from 'styled-components';

export const FileUpload = styled.input`
  display: none;
`;

export const Wrapper = styled.label`
  cursor: pointer;

  button {
    pointer-events: none;
  }
`;

export const ProgressContainer = styled.div`
  margin-top: 15px;
  text-align: center;
`;

export const ProgressBar = styled.progress`
  width: 100%;
  max-width: 360px;
`;
